import classnames from 'classnames';

import styles from './index.module.scss';

export default function LoginCommonBox(props) {
  return (
    <div className={classnames(styles['clg-mod'], props.className)}>
      <div className={styles['clg-mod-tab']}>
        {props.title && <div className={styles['clg-mod-title']}>{props.title}</div>}
        {props.desc && <div className={styles['clg-mod-desc']}>{props.desc || ''}</div>}
        {props.children}
      </div>
    </div>
  );
}

LoginCommonBox.Footer = (props) => {
  return (
    <div
      className={classnames(styles['clg-back-mod'], props.className, {
        [styles['clg-back-mod_center']]: props.center,
      })}
    >
      <div className={styles['clg-back-mod-item']}>
        <i className={styles['clg-icon-link-left']}></i>
        {props.left}
      </div>
      {props.children}
    </div>
  );
};

LoginCommonBox.SutTitle = (props) => {
  return (
    <div className={styles['clg-mod-desc']} style={props.style}>
      {props.children}
    </div>
  );
};
